import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track", "prev", "next"]

  connect() {
    this.update()
  }

  next() {
    this.trackTarget.scrollBy({ left: this.trackTarget.clientWidth, behavior: "smooth" })
  }

  prev() {
    this.trackTarget.scrollBy({ left: -this.trackTarget.clientWidth, behavior: "smooth" })
  }

  update() {
    const track = this.trackTarget
    const scrollable = track.scrollWidth > track.clientWidth

    if (!scrollable) {
      this.prevTarget.classList.add("hidden")
      this.nextTarget.classList.add("hidden")
      return
    }

    this.prevTarget.classList.remove("hidden")
    this.nextTarget.classList.remove("hidden")

    const atStart = track.scrollLeft <= 0
    const atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1

    this.prevTarget.classList.toggle("opacity-30", atStart)
    this.prevTarget.classList.toggle("pointer-events-none", atStart)
    this.nextTarget.classList.toggle("opacity-30", atEnd)
    this.nextTarget.classList.toggle("pointer-events-none", atEnd)
  }
}
